import { compose, mdsWidget } from 'dojo/_base/declare';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './LabourReviewTable.html?raw';
import "../../../moreCore/UI/GenericDialog/GenericDialog";

const domConstruct: any = domConstructTyped;

class LabourReviewTable extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    data: any = null;
    sumData: any = null;
    mode = "daily"; // "summary"


    setData(entitylist: any, mode: any) {
        this.data = entitylist.taskExecutions;
        this.sumData = entitylist.sums;

        if (mode == "daily" || mode == "summary") {
            this.mode = mode;
        }

        this.drawTable();
    }

    _drawSumRow(targetContainer: any, dSumDuration: any, dSumWorkUnits: any) {
        // Summenzeile!

        let trSum = domConstruct.create("tr", {}, targetContainer);

        let dSumLaborHours = dSumWorkUnits;// / 4;

        domConstruct.create("td", {
            innerHTML: this.translations["LabourReview__Table_ColSum"],
            "className": "sum label"
        }, trSum);

        if (dSumDuration != null) {
            dSumDuration = dSumDuration / 60;

            domConstruct.create("td", {
                innerHTML: "",//dSumDuration.toLocaleString('de-DE', { minimumFractionDigits: 2 }),
                "className": "sum value"
            }, trSum);
        }

        domConstruct.create("td", {
            innerHTML: this.translations["LabourReview__Table_ColSumFormat"].format(
                dSumWorkUnits.toLocaleString('de-DE'),
                dSumLaborHours.toLocaleString('de-DE', { minimumFractionDigits: 1 })),
            "className": "sum value"
        }, trSum);


    }

    drawTable() {
        domClass.add(this.emptyResultsContainer, "w3-hide");
        domClass.add(this.tableContainer, "w3-hide");
        domClass.add(this.tableSumContainer, "w3-hide");

        let dateFormat_ddMMyyyy_HHmm: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        let dateFormat_HHmm: any = { hour: '2-digit', minute: '2-digit' };
        let dateFormat_ddMMyyyy: any = { year: 'numeric', month: '2-digit', day: '2-digit'/*, hour: '2-digit', minute: '2-digit'*/ };
        let dateFormat_dddd_ddMMyyyy: any = { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long'/*, hour: '2-digit', minute: '2-digit'*/ };

        domConstruct.empty(this.tbodyContainer);
        domConstruct.empty(this.tbodySumContainer);

        if (this.data) {
            if (this.data.length == 0) {
                domClass.remove(this.emptyResultsContainer, "w3-hide");

                return;
            }

            let previousWeekDay = null;
            let dSumWorkUnits = 0;
            let dSumDuration = 0;

            for (let i = 0; i < this.data.length; i++) {
                let entity = this.data[i];

                let date = new Date(entity.date_start);//dojoDate.parse(value, { datePattern: "yyyy-MM-dd", selector: "date" });
                let dateEnd = new Date(entity.date_end);

                let weekDay = date.toLocaleDateString('de-DE', dateFormat_dddd_ddMMyyyy);

                // Gruppenzeile!
                if (weekDay != previousWeekDay) {


                    if (previousWeekDay != null) {

                        this._drawSumRow(this.tbodyContainer, dSumDuration, dSumWorkUnits);

                        dSumWorkUnits = 0;
                        dSumDuration = 0;

                        // Abstand zum nächsten Wochentag:

                        let tr = domConstruct.create("tr", {}, this.tbodyContainer);

                        domConstruct.create("td", {
                            innerHTML: "",
                            "colspan": "3",
                            "className": "empty"
                        }, tr);
                    }

                    previousWeekDay = weekDay;

                    let tr = domConstruct.create("tr", {}, this.tbodyContainer);

                    domConstruct.create("td", {
                        innerHTML: previousWeekDay,
                        "colspan": "3",
                        "className": "dayHeading",
                        "id": date.toLocaleDateString("de-DE", dateFormat_ddMMyyyy)
                    }, tr);

                    let trHead = domConstruct.create("tr", {}, this.tbodyContainer);

                    domConstruct.create("td", {
                        innerHTML: this.translations["LabourReview__Table_Colhead_TaskNo"],
                        "colspan": "",
                        "className": "colHead"
                    }, trHead);

                    domConstruct.create("td", {
                        innerHTML: this.translations["LabourReview__Table_Colhead_Date"],
                        "colspan": "",
                        "className": "colHead"
                    }, trHead);

                    domConstruct.create("td", {
                        innerHTML: this.translations["LabourReview__Table_Colhead_LaborUnits"],
                        "colspan": "",
                        "className": "colHead"
                    }, trHead);
                }

                let tr = domConstruct.create("tr", {}, this.tbodyContainer);

                let colTaskNo = domConstruct.create("td", {
                    innerHTML: entity.ref_Task.Number
                }, tr);

                if (entity.tmp_task_numbers_www) {
                    domAttr.set(colTaskNo, "innerHTML", entity.tmp_task_numbers_www);
                }

                else if (entity.tmp_weblink_label) {

                    if (entity.tmp_weblink_label_occurrence) {
                        domAttr.set(colTaskNo, "innerHTML", entity.tmp_weblink_label + "<br>(" + entity.tmp_weblink_label_occurrence + ")");
                    } else {
                        domAttr.set(colTaskNo, "innerHTML", entity.tmp_weblink_label);
                    }
                }

                else if (entity.tmp_weblink) {
                    colTaskNo.innerHTML = "";
                    domConstruct.create("a", {
                        "href": entity.tmp_weblink,
                        "target": "new",
                        "innerHTML": entity.ref_Task.Number
                    }, colTaskNo);
                }

                domConstruct.create("td", {
                    innerHTML: "{0} - {1}".format(
                        date.toLocaleDateString('de-DE', dateFormat_ddMMyyyy_HHmm),
                        dateEnd.toLocaleDateString('de-DE', dateFormat_HHmm)
                    )
                }, tr);

                let laborUnits = entity.labor_units;
                let laborHours = laborUnits;// / 4;

                domConstruct.create("td", {
                    innerHTML: this.translations["LabourReview__Table_ColSumFormat"].format(
                        laborUnits.toLocaleString('de-DE'),
                        laborHours.toLocaleString('de-DE', { minimumFractionDigits: 1 }))
                }, tr);

                dSumDuration += entity.duration;
                dSumWorkUnits += entity.labor_units;
            }

            this._drawSumRow(this.tbodyContainer, dSumDuration, dSumWorkUnits);

            domClass.remove(this.tableContainer, "w3-hide");

        }

        if (this.sumData) {
            let dSumDuration = null;
            let dSumWorkUnits = 0;

            for (let i = 0; i < this.sumData.totalsDaily.length; i++) {

                let entry = this.sumData.totalsDaily[i];

                let day = new Date(entry.day);
                let laborUnits = entry.laborUnits;

                let link = day.toLocaleDateString("de-DE", dateFormat_ddMMyyyy)

                let tr = domConstruct.create("tr", {}, this.tbodySumContainer);

                let td = domConstruct.create("td", {}, tr);

                domConstruct.create("a", {
                    innerHTML: day.toLocaleDateString('de-DE', dateFormat_dddd_ddMMyyyy),
                    "href": "#" + link,
                    "className": "mds-hover-dark"
                }, td);

                let laborHours = laborUnits;// / 4;

                domConstruct.create("td", {
                    innerHTML: this.translations["LabourReview__Table_ColSumFormat"].format(
                        laborUnits.toLocaleString('de-DE'),
                        laborHours.toLocaleString('de-DE', { minimumFractionDigits: 1 }))
                }, tr);

                dSumWorkUnits += laborUnits;
            }

            this._drawSumRow(this.tbodySumContainer, null, dSumWorkUnits);


            domClass.remove(this.tableSumContainer, "w3-hide");
        }
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate() {
        super.postCreate.apply(this, arguments as any);
    }

    startup() {
        super.startup.apply(this, arguments as any);

    }
    destroy() {
        super.destroy.apply(this, arguments as any);
    }


}
LabourReviewTable.prototype.declaredClass = 'WidgetCollection.JDM.LabourReview.LabourReviewTable';

export default mdsWidget(LabourReviewTable);
